export default __webpack_public_path__ + "static/media/imone-dropdown.c07193e1.webp";